import React, { useState, useEffect } from 'react'
import OneDaayTourCard from './components/OneDayTourCard'
import OneDayTourHero from "./components/OneDayTourHero";
import CityCard from './components/CityCard';
import { getAllDestination } from 'services/apiServices'
import { getAvatar } from 'services/apiServices';
import SectionSubHero from 'components/SectionSubHero';
import { Helmet } from "react-helmet";
import LoadingSpinner from 'components/LoadingSpinner';
import NoDataFound from 'components/NoDataFound';

const OneDayTournew = () => {


    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);



    const fetchData = async () => {
        setLoading(true)
        try {
            const response: any = await getAllDestination();
            if (response.data.response === 'success') {
                console.log(data)
                setData(response.data.data.rows)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData();
    }, [])




    return (
        <div
            className={`nc-PageVantours relative overflow-hidden`}
            data-nc-id="PageVantours"
        >
            <Helmet>
                <title>ONE DAY TOUR | EUROPE TOURS & TRAVELS</title>
            </Helmet>
            {/* <OneDayTourHero className='mb-11' /> */}
            <SectionSubHero
                title="One Day Tours"
                pillTitle="Day Trip"
                bgClass="dashboard-odt-bg"
                description="Discover top attractions in a single day with a well-planned, enjoyable guided tour."
                className="pl-6 pt-10 lg:pt-10 lg:pb-10 mb-16"
            />

            {/* <div className='items-center text-center  space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8 mx-5 my-6 shadow-2xl'> */}
            <div className="container relative mt-4 md:mt-0 lg:mt-0 xl:mt-0 pb-24 lg:pt-16 lg:pb-16">
                {loading && (
                    <LoadingSpinner text="Loading One Day Tours..." />
                )}

                {!loading && data.length === 0 &&  (
                    <NoDataFound
                        title="No One Day Tours Available"
                        description="We couldn't find any one day tours at the moment. Please check back later."
                    />
                )}
                {/* <CityCard data={item} /> */}
                {data.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-2 xl:grid-cols-2 gap-6 mx-10">
                    {data.map((item: any, index: any) => {
                        return <CityCard data={item} fetchData={fetchData} />
                    })}
                </div> : <p> </p>}


            </div>
        </div>
    )
}

export default OneDayTournew